const data = {
  p1: {
    title: "AI互动营销平台",
    subtitle: "AI营销专员7x24小时自动获客"
  },
  p2: {
    img: "p2Img",
    title: "基于主流新媒体平台，全面助力B端客户",
    subtitle: "缩短获客转化链路、提高成交转化效率",
    desc: "产品面向提高营销获客转化效率的企业核心场景，并通过轻量级AI营销员（智能体）&知识库能力降低企业运营成本，快速实现跨平台营销获客。"
  },
  p3: {
    title: "产品优势",
    img: "p3Img1",
    list: [
      [
        {
          title: "AI营销专员",
          desc: "突破传统客服被动响应模式，通过大模型驱动的「AI营销专员」，将私信场景转化为主动获客阵地"
        },
        {
          title: "多平台深度接入",
          desc: "接入抖音、小红书、视频号等主流新媒体营销平台的最新商业转化能力，最大限度发挥各平台优势，缩短转化链路"
        }
      ],
      [
        {
          title: "自主智能驱动",
          desc: "依托智能营销策略与企业知识库双轮驱动，精准捕捉用户需求，实现从「问题解答」到「商机转化」的效率跃升"
        },
        {
          title: "跨平台管理",
          desc: "实现「一个后台账号、多平台管理」的高效运营模式，无需频繁切换平台，即可实时响应多渠道客户的咨询与潜在商机"
        }
      ]
    ]
  },
  p4: {
    title: "AI互动营销应用价值",
    highlightTitle: "应用价值",
    list: [
      {
        title: "线索获客",
        desc: "一对一私信触达，主动挖掘客户需求，以个性化、有温度的对话提升客户好感度与信任度，实现从线索到客户的高效转化",
        index: 1,
        img: "p4Img1"
      },
      {
        title: "成交转化",
        desc: "客户进入对话后，主动推送个性化营销内容，借助营销组件工具缩短决策链路，助力企业高效完成交易转化",
        index: 2,
        img: "p4Img2"
      },
      {
        title: "话题互动",
        desc: "围绕产品热点进行AI话题互动，自然植入产品优势，强化用户认同感，提升账号活跃度，带动粉丝持续增长",
        index: 3,
        img: "p4Img3"
      },
      {
        title: "在线客服",
        desc: "7×24 小时在线响应，AI快速理解用户咨询意图，精准解答常见问题，多平台消息统一管理，优化客户服务体验，促进业务增长",
        index: 4,
        img: "p4Img4"
      }
    ]
  },
  p5: {
    title: "AI助力",
    highlightTitle: "无人化获客",
    list: [
      {
        title: "全时自主运营",
        desc: "依托大模型的语义理解与决策能力，AI营销员无需人工干预即可完成「用户意图识别-知识库检索-营销话术回复-转化链路引导」全流程，实现7×24小时无间断获客",
        img: "p5Img1",
        icon: "p5Icon1",
        index: 1
      },
      {
        title: "成本效能跃升",
        desc: "单企业部署3名AI营销专员即可覆盖3大平台获客需求，对比传统人工团队可降低70%人力成本，同时线索获取量提升4倍，真正实现由「数字劳动力」带来的营销效率革命",
        img: "p5Img2",
        icon: "p5Icon2",
        index: 2
      }
    ]
  }
};
export default data;
